"use strict";
// конвертуємо зарплату у число
function getSalaryNumber(el) {
    return Number(el.dataset.salary.replace(/[$,]/g, "")); // прибираємо $ і коми
}
// сортування списку у спадному порядку
function sortList(list) {
    var items = Array.from(list.children);
    items.sort(function(a, b) {
        return getSalaryNumber(b) - getSalaryNumber(a);
    });
    items.forEach(function(item) {
        return list.appendChild(item);
    }); // оновлюємо DOM
}
// отримання масиву об'єктів співробітників
function getEmployees(list) {
    return Array.from(list.children).map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: Number(item.dataset.salary.replace(/[$,]/g, "")),
            age: Number(item.dataset.age)
        };
    });
}
var employeeList = document.querySelector("ul");
if (employeeList) {
    sortList(employeeList); // сортуємо список у DOM
    getEmployees(employeeList);
}

//# sourceMappingURL=index.378b4783.js.map
